import { Card, VStack } from '@chakra-ui/react';

import { Icon, IconMonitorPlay, IconUser } from '@/components';
import { SidebarItem } from '@/components/SidebarItem';
import i18n from '@/lib/i18n/client';

import { ACCOUNT_PATH } from './constants';

const SETTINGS_MENU_OPTIONS = [
  {
    title: i18n.t('coach:settings.interviews'),
    icon: <Icon icon={IconUser} fontSize="lg" color="brand.500" />,
    url: `${ACCOUNT_PATH}/interviews`,
  },
  {
    title: i18n.t('coach:settings.cvAnalysis.cvAnalysis'),
    icon: <Icon icon={IconMonitorPlay} fontSize="lg" color="brand.500" />,
    url: `${ACCOUNT_PATH}/cv-analysis`,
  },
] as const;

export const AccountSettingsNav = () => {
  return (
    <Card p={6} borderColor="gray.50">
      <VStack gap={3}>
        {SETTINGS_MENU_OPTIONS.map((item) => (
          <SidebarItem
            key={item.url}
            url={item.url}
            title={item.title}
            icon={item.icon}
          />
        ))}
      </VStack>
    </Card>
  );
};
